/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'

import { Menu, Modal } from 'antd'

import { UIFormSection, UIInfoSidebar } from '../../../components'

import { employeesService } from '../../../redux/services'
import { equipmentsService } from '../../../redux/services'
import { formatTzDate } from '../../../utils/formatTzDate'

const config = {
  searchPlaceholder: 'Buscar funcionário',
}

export const EXPORT_FORMAT_ITEMS = [
  {
    key: 'cpf',
    label: 'CPF',
  },
  {
    key: 'pis',
    label: 'PIS',
  },
];

class Index extends Component {
  constructor(props) {
    super(props)

    this.state = {
      listType: 'list',
      dataAll: [],
      data: [],
      pagination: {
        current: 1,
        pageSize: 30,
        total: 0,
      },
      search: '',
      // Owner item
      ownerItem: {},
      // Actions
      editModalVisible: false,

      isExporting: false,
    }
  }

  init = (ownerItem) => {
    this.setState({
      ownerItem: ownerItem,
    }, () => {
      this.fetchGetAll()
    })
  }

  /**
   * Create
   */
  createOpen = () => {
    this.setState({ createModalVisible: true })

    // On open screen
    this.createScreen.onOpen()
  }

  createOnClose = () => {
    this.setState({ createModalVisible: false })
  }

  createOnComplete = () => {
    this.setState({ createModalVisible: false })

    // Fetch all
    this.fetchGetAll()
  }

  /**
   * Edit
   *
   * @param uuid
   */
  editOpen = ({ uuid }) => {
    this.setState({ editModalVisible: true })

    // On open screen
    this.editScreen.onOpen(uuid)
  }

  /**
   * Delete
   *
   * @param uuid
   */
  deleteConfirm = ({ uuid }) => {
    Modal.confirm({
      title: 'Confirmar exclusão!',
      content: 'Tem certeza de que deseja excluir este registro?',
      okText: 'Excluir',
      autoFocusButton: null,
      onOk: () => {
        return this.deleteConfirmed(uuid)
      },
    })
  }

  deleteConfirmed = (uuid) => {
    return employeesService
      .destroy(this.state.ownerItem.uuid, uuid)
      .then((response) => {
        // Fetch all
        this.fetchGetAll()
      })
      .catch((data) => {
        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
        })
      })
  }

  editOnComplete = () => {
    this.setState({ editModalVisible: false })

    // Fetch all
    this.fetchGetAll()
  }

  menuItem = (item) => (
    <Menu className="actions-dropdown-menu">
      <Menu.Item key="edit">
        <a onClick={() => this.editOpen(item)}>
          <i className="fal fa-pen" />
          Editar
        </a>
      </Menu.Item>
      <Menu.Item key="delete" className="divider btn-delete">
        <a onClick={() => this.deleteConfirm(item)}>
          <i className="fal fa-trash" />
          Excluir
        </a>
      </Menu.Item>
    </Menu>
  )

  columns = () => [
    {
      title: 'Nome',
      render: (item) => item?.nome ?? '-',
    },
    {
      title: 'Departamento',
      render: (item) => item?.contrato[0]?.departamento?.nome ?? '-',
    },
    {
      title: 'Função',
      render: (item) => item?.contrato[0]?.funcoes?.nome ?? '-',
    },
  ]

  export = (format) => {
    const { ownerItem } = this.state
    this.setState({ isExporting: true }, () => {
      this.props.onExportingChange && this.props.onExportingChange(true)

      equipmentsService
      .exportFuncionarioAll(ownerItem.uuid, { format })
      .then((response) => {
        const { file_url } = response?.data || {};
        const link = document.createElement('a');
          link.href = file_url;
          const file_name = file_url.substr(file_url.lastIndexOf('/') + 1);
          link.download = file_name;
          link.setAttribute('download', file_name);
          link.target = '_blank';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
      })
      .catch((data) => {
        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
        })
      })
      .finally(() => {
        this.setState({ isExporting: false });
        this.props.onExportingChange && this.props.onExportingChange(false)
      });
    })

    // TODO Thiago

    // formato / data

  }

  fetchGetAll = (init = false, exportItems = false) => {
    const { pagination, search, ownerItem } = this.state

    this.setState({
      isLoading: true,
    })

    const data = {
      limit: 30,
      nome: this.state.search,
      equipamento_id: ownerItem.uuid,
    }

    if (exportItems) {
      data.exportItems = true
    } else {
      data.page = init ? 1 : pagination.current
      data.limit = pagination.pageSize
    }

    equipmentsService
      .getEmployeesEquipment(data)
      .then((response) => {
        this.setState((state) => ({
          isLoading: false,
          data: response.data.data,
          dataAll: response.data.data,
          pagination: {
            ...state.pagination,
            current: response.data.meta.current_page,
            total: response.data.meta.total,
          },
        }))
      })
      .catch((data) => {
        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
        })
      })
  }

  searchItems = () => {
    const { search } = this.state
    const newData = [...this.state.dataAll]

    this.setState({
      data: search
        ? newData.filter(
            (item) =>
              item?.nome.toLowerCase().indexOf(search.toLowerCase()) !== -1 ||
              item?.nome.toLowerCase().indexOf(search.toLowerCase()) !== -1
          )
        : newData,
    })
  }

  editOnClose = () => {
    this.setState({ editModalVisible: false })
  }

  onSearch = (value) => {
    this.setState(
      {
        search: value,
      },
      () => {
        this.searchItems()
      }
    )
  }

  onSearchChange = (e) => {
    // If it does not have type then it's cleaning
    if (!e.hasOwnProperty('type')) {
      const { search } = this.state

      this.setState(
        {
          search: e.target.value,
        },
        () => {
          if (search) {
            this.searchItems()
          }
        }
      )
    }
  }

  onMenuClick = (e) => this.export(e.key);

  render() {
    const { data, ownerItem } = this.state
    const columns = this.columns()

    return (
      <div className="form-layout-with-sidebar">
        <div className="form-layout-main">
          <UIFormSection
            icon={<i className="fal fa-clipboard-list" />}
            title="Prévia da exportação"
            description="Esta é a lista de funcionários que será exportada e enviada ao equipamento."
            extra={
              <div className="stat-counter">
                <div className="stat-counter-icon">
                  <i className="fal fa-users" />
                </div>
                <div>
                  <p className="stat-counter-value">{data.length}</p>
                  <p className="stat-counter-label">funcionários serão exportados</p>
                </div>
              </div>
            }
          >
            <div className="list-items list-type">
              <div className="list-items-header">
                <div className="row">
                  {columns.map((column, index) => (
                    <div className="col" key={index}>
                      <div>{column.title}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="list-items-body">
                {data.map((item, index) => (
                  <div className="list-items-item" key={index}>
                    <div className="row">
                      {columns.map((column, colIndex) => (
                        <div className="col" data-title={column.title} key={colIndex}>
                          <div>{column.render(item)}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </UIFormSection>
        </div>
        <div className="form-layout-sidebar">
          <UIInfoSidebar
            icon={<i className="fal fa-info-circle" />}
            title="Informações da exportação"
            items={[
              {
                title: 'Equipamento',
                description: ownerItem.marca && ownerItem.modelo ? `${ownerItem.marca} - ${ownerItem.modelo}` : '-',
              },
              {
                title: 'Modelo de exportação',
                description: 'Padrão do equipamento. A estrutura e os campos seguem o modelo definido para este equipamento.',
              },
              {
                icon: <i className="fal fa-calendar-alt" />,
                title: 'Última atualização',
                description: ownerItem.updated_at ? formatTzDate(ownerItem.updated_at, ownerItem?.configuracao?.fuso_horario || '-03:00') : '-',
              },
              {
                icon: <i className="fal fa-comment-alt" />,
                title: 'Observações',
                description: 'Apenas funcionários ativos e vinculados ao equipamento são considerados na exportação.',
              },
            ]}
            tip={{
              icon: <i className="fal fa-shield-check" />,
              title: 'Dados seguros',
              description: 'A exportação ocorre de forma segura e os dados são transmitidos com criptografia.',
            }}
          />
        </div>
      </div>
    )
  }
}

export default Index
